export const male_beards = [ //An array of each Facial Hair's ID and Name. There are 14.
  {
    id: '', //For facial hair, append ? to find id of div. 
    name: 'Clean Shavenly' //Show name in textbox.
  },
  {
    id: '7',
    name: 'Daddy O' /* From FO4 */
  },
  {
    id: '14',
    name: 'fourteen'
  },
  {
    id: '6',
    name: 'six'
  },  
  {
    id: '13',
    name: 'Survivalist' /* From F04, Old Longfellow. */
  },
  {
    id: '5',
    name: 'Lazy Morning' /* From FO4, Preston Garvey. */
  },
  {
    id: '12',
    name: 'twelve'
  },
  {
    id: '11',
    name: 'The Gentleman' /* From FO4. Alternatively Suave. */
  },
  {
    id: '10',
    name: 'ten'
  },
  {
    id: '9',
    name: 'nine'
  },
  {
    id: '8',
    name: 'eight'
  },
  {
    id: '4',
    name: 'four'
  },
  {
    id: '3',
    name: 'three'
  },
  {
    id: '2',
    name: 'Van Dyke beard'
  }
]